(() => {
  const roots = [...document.querySelectorAll('[data-revic-offer-root]')];
  if (!roots.length) return;
  const productOffer = roots.find(root => root.dataset.revicOfferMode === 'product');
  if (productOffer) {
    const placeOffer = () => {
      const price = document.querySelector('#MainContent .product-details product-price');
      if (price && price.nextElementSibling !== productOffer) price.after(productOffer);
    };
    placeOffer();
    const productDetails = document.querySelector('#MainContent .product-details');
    if (productDetails) new MutationObserver(placeOffer).observe(productDetails, { childList: true, subtree: true });
  }

  const start = Date.parse('2026-10-20T16:00:00Z');
  const end = Date.parse('2026-11-03T16:00:00Z');
  let anchor = null, timer, busy = false;
  const hide = () => roots.forEach(root => {
    root.querySelectorAll('[data-revic-offer-active]').forEach(el => { el.hidden = true; });
    root.querySelectorAll('[data-revic-offer-inactive]').forEach(el => { el.hidden = false; });
  });
  const paint = () => {
    clearTimeout(timer);
    if (!anchor || document.visibilityState !== 'visible') { hide(); return; }
    const elapsed = performance.now() - anchor.mono;
    const earliest = anchor.utc + elapsed;
    const latest = earliest + anchor.uncertainty;
    const active = elapsed < 90000 && earliest >= start && latest < end;
    roots.forEach(root => {
      root.querySelectorAll('[data-revic-offer-active]').forEach(el => { el.hidden = !active; });
      root.querySelectorAll('[data-revic-offer-inactive]').forEach(el => { el.hidden = active; });
    });
    const next = earliest < start ? start - earliest : active ? end - latest : 30000;
    timer = setTimeout(paint, Math.max(1, Math.min(next, 30000)));
  };
  const sync = async () => {
    if (busy) return;
    busy = true;
    hide();
    try {
      const began = performance.now();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      let response;
      try {
        const base = window.Shopify?.routes?.root || '/';
        response = await fetch(base + 'cart.js?revic_offer_clock=' + crypto.randomUUID(), {
          method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: controller.signal
        });
      } finally { clearTimeout(timeout); }
      const utc = Date.parse(response.headers.get('Date'));
      const age = Number(response.headers.get('Age') || 0);
      const latency = performance.now() - began;
      if (!response.ok || !Number.isFinite(utc) || age > 1 || latency > 5000) throw new Error('Unverified clock');
      anchor = {utc, mono:performance.now(), uncertainty:1000 + latency};
      paint();
    } catch { anchor = null; hide(); }
    finally { busy = false; }
  };
  document.addEventListener('visibilitychange', () => {
    hide(); anchor = null;
    if (document.visibilityState === 'visible') sync();
  });
  window.addEventListener('pageshow', sync);
  window.addEventListener('online', sync);
  window.addEventListener('offline', () => {anchor = null; hide();});
  setInterval(sync, 60000);
  sync();
})();
